import DocumentUpload from '@/app/common/components/DocumentUpload'
import FamilyWizardLayout from '@/app/pages/family_application/FamilyWizardLayout.tsx'
import { useWizardContext } from '@/app/pages/family_application/income_verification/IncomeVerificationWizardProvider.tsx'
import {
  FrameCornerIcon
} from '@/common/icons/general.tsx'
import { AppRoutePaths } from '@/routing/route_paths.ts'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function ResidencyDocumentCapture() {
  const { t: translate } = useTranslation()
  const { updateFormData, formData } = useWizardContext()
  const navigate = useNavigate()

  function saveImage(file: File) {
    updateFormData('DateOfBirthFile' as keyof typeof formData, file)
    navigate(
      AppRoutePaths.family_application.residency_verification.document_review
    )
  }

  return (
    <FamilyWizardLayout>
      <FamilyWizardLayout.Header>
        {translate('residency_verification')}
      </FamilyWizardLayout.Header>
      <FamilyWizardLayout.Content className="w-full">
        <DocumentUpload
          uploadInformation={
            <div className="mt-4">
              <div className="flex items-center">
                <div className="w-5 flex justify-center">
                  <FrameCornerIcon />
                </div>
                <div className="ml-4 text-sm">
                  {translate('position_your_document_residency_verification')}
                </div>
              </div>
            </div>
          }
          onUpload={(file) => {
            saveImage(file[0])
          }}
        />
      </FamilyWizardLayout.Content>
    </FamilyWizardLayout>
  )
}
